import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import HospitalizationPlan, {
  HospitalizationStatus,
  IN_PROGRESS_STATUSES,
} from 'model/HospitalizationPlan'

export class HospitalizationPlansRepository extends WebRepository<HospitalizationPlan> {
  constructor() {
    super(new Api('hospitalization_plans'))
  }

  /** Every admission recorded for a patient, newest first. */
  async searchByPatient(patientId: string): Promise<HospitalizationPlan[]> {
    return super.search({
      selector: { patientId: { $eq: patientId } },
      sort: [{ startedAt: 'desc' }],
      limit: 50,
    })
  }

  /**
   * Everything currently in the hospitalization flow, across patients — activated admissions plus
   * screenings still in progress, since a pending decision is itself work the ward has to pick up.
   */
  async findAllOngoing(): Promise<HospitalizationPlan[]> {
    return super.search({
      selector: {
        status: { $in: [HospitalizationStatus.active, ...IN_PROGRESS_STATUSES] },
      },
      sort: [{ startedAt: 'asc' }],
      limit: 500,
    })
  }

  /** The admission currently running for a patient, if any. */
  async findActiveByPatient(patientId: string): Promise<HospitalizationPlan | undefined> {
    const plans = await super.search({
      selector: { patientId: { $eq: patientId }, status: { $eq: HospitalizationStatus.active } },
      sort: [{ startedAt: 'desc' }],
      limit: 1,
    })
    return plans[0]
  }
}

export default new HospitalizationPlansRepository()
